import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { FormFieldItem, FormItem, FormPageItem, Lang } from 'src/app/models/forms';

@Injectable({ providedIn: 'root' })
export class FromService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // ✅ pages list (page_type_id=8)
  getFormPages(lang: Lang) {
    return this.http.get<{ status: string; data: FormPageItem[] }>(
      `${this.api}admin/forms/pages`,
      { params: { lang } }
    );
  }

  // ✅ forms list (optionally filtered by menu_page)
  getForms(lang: Lang, menu_page?: number) {
    const params: any = { lang };

    if (menu_page) {
      params.menu_page = menu_page;
    }

    return this.http.get<{ status: string; data: FormItem[] }>(
      `${this.api}admin/forms`,
      { params }
    );
  }

  showForm(id: number, lang: Lang) {
    return this.http.get<{ status: string; data: FormItem }>(
      `${this.api}admin/forms/${id}`,
      { params: { lang } }
    );
  }

  createForm(payload: Partial<FormItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FormItem }>(
      `${this.api}admin/forms`,
      payload,
      { params: { lang } }
    );
  }

  updateForm(id: number, payload: Partial<FormItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FormItem }>(
      `${this.api}admin/forms/${id}`,
      payload,
      { params: { lang } }
    );
  }

  deleteForm(id: number, lang: Lang, soft: boolean = true) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/forms/${id}/delete`,
      { soft },
      { params: { lang } }
    );
  }

  toggleVisible(id: number, lang: Lang) {
    return this.http.post<{ status: string; message: string; visible: number }>(
      `${this.api}admin/forms/${id}/toggle-visible`,
      {},
      { params: { lang } }
    );
  }

  // ✅ fields API (needs backend)
  getFields(formId: number, lang: Lang) {
    return this.http.get<{ status: string; data: FormFieldItem[] }>(
      `${this.api}admin/forms/${formId}/fields`,
      { params: { lang } }
    );
  }

  createField(formId: number, payload: Partial<FormFieldItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FormFieldItem }>(
      `${this.api}admin/forms/${formId}/fields`,
      payload,
      { params: { lang } }
    );
  }

  updateField(formId: number, fieldId: number, payload: Partial<FormFieldItem>, lang: Lang) {
    return this.http.post<{ status: string; data: FormFieldItem }>(
      `${this.api}admin/forms/${formId}/fields/${fieldId}`,
      payload,
      { params: { lang } }
    );
  }

  deleteField(formId: number, fieldId: number, lang: Lang) {
    return this.http.post<{ status: string; message: string }>(
      `${this.api}admin/forms/${formId}/fields/${fieldId}/delete`,
      {},
      { params: { lang } }
    );
  }

  sortFields(formId: number, ids: number[], lang: Lang) {
    return this.http.post<{ status: string }>(
      `${this.api}admin/forms/${formId}/fields/sort`,
      { ids },
      { params: { lang } }
    );
  }


  getSubmissions(formId: number, lang: Lang) {
    return this.http.get<any>(
      `${this.api}admin/forms/${formId}/submissions`,
      { params: { lang } }
    );
  }

  getSubmission(submissionId: number) {
    return this.http.get<any>(
      `${this.api}admin/forms/submissions/${submissionId}`
    );
  }

  deleteSubmission(submissionId: number) {
    return this.http.delete<any>(
      `${this.api}admin/forms/submissions/${submissionId}`
    );
  }


}